<section *ngIf="allDocuments && topSansSelectionMedicale !== undefined" class="simulation grid-container grid-container--section no-gutter-mobile">
    <app-stepper-component [currentStepId]="topSansSelectionMedicale ? 'info_doc_download' : 'qs'"></app-stepper-component>
    <div>
        <form>
            <fieldset class="simulation__step" name="adhesionForm">
                <legend style="display: none">{{ 'consents.title' | i18n }}</legend>
                <div>
                    <div class="grid-mobile-4 pull-mobile-0 no-gutter grid-12">
                        <section class="consents">
                            <div class="simulation__group">
                                <h1 class="page-title page-title--primary">
                                    {{ (topSansSelectionMedicale ? 'consents.title.SSM' : 'consents.title') | i18n }}
                                </h1>
                                <div class="simulation__content">
                                    <app-consentement-info
                                        [personne]="personne"
                                        [idPropositionPrincipale]="idPropositionPrincipale"
                                        [conventionAERAS]="conventionAERAS"
                                        [droitOubli]="droitOubli"
                                        [topSansSelectionMedicale]="topSansSelectionMedicale"
                                    >
                                    </app-consentement-info>
                                    <app-consentement-form
                                        [idDossier]="idDossier"
                                        [personne]="personne"
                                        [idPropositionPrincipale]="idPropositionPrincipale"
                                        [consentementDoc]="consentementDoc"
                                        [noticeDoc]="noticeDoc"
                                        [droitOubli]="droitOubli"
                                        [conventionAERAS]="conventionAERAS"
                                        [topSansSelectionMedicale]="topSansSelectionMedicale"
                                    >
                                    </app-consentement-form>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </fieldset>
        </form>
    </div>
</section>
<app-steps-adhesion-modal *ngIf="topSansSelectionMedicale !== undefined" [currentStepId]="topSansSelectionMedicale ? 'info_doc_download' : 'qs'"> </app-steps-adhesion-modal>
